module.exports = __webpack_public_path__ + "static/media/glass3.bd99f45d.jpg";